<script setup>
import { router } from '@inertiajs/vue3'
const props = defineProps({
    title: String,
});

let programme = router.page.props.ziggy.programme;
let organisation = router.page.props.ziggy.organisation;

if (router.page.props.preview) {
    programme = router.page.props.programme;
    organisation = router.page.props.organisation;
}

const theme_color_1 = (!programme || (programme.theme_color_1 == null || programme.theme_color_1 == '')) ? '#83C341' : programme.theme_color_1;
const theme_color_2 = (!programme || (programme.theme_color_2 == null || programme.theme_color_2 == '')) ? '#E5F2D7' : programme.theme_color_2;
const theme_color_3 = (!programme || (programme.theme_color_3 == null || programme.theme_color_3 == '')) ? '#ffffff' : programme.theme_color_3;
const content_wrapper_color = (!programme || (programme.theme_color_3 == null || programme.theme_color_3 == '')) ? '#F0EFF5' : programme.theme_color_3;
const theme_color_4 = (!programme || (programme.theme_color_4 == null || programme.theme_color_4 == '')) ? '#83C341' : programme.theme_color_4;
let background_image = null;
if (organisation) {
    if (organisation.background_image != null && organisation.background_image != '') {
        background_image = '/storage/' + organisation.background_image;
    }
}

</script>

<template>

    <component :is="'style'">

        #content-wrapper {
            background-color: {{content_wrapper_color}};
            background-image: url('{{background_image}}');
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            height: 100%;
        }

        #content-wrapper.auditor-content-wrapper {
            background-color: #e9e9e9;
            background-image: none;
        }

        .sos-programme-form-card {
            background-color: {{theme_color_1}};
        }
        .sos-programme-content-card {
            border: solid 5px {{theme_color_1}};
            background-color: {{theme_color_3}}
        }
        #col-intro .sos-programme-content-card h1,
        #sos-programme-dashboard-content h2.dashboard-title,
        .sos-programme-dashboard-content .dashboard-title,
        .auditor-content-wrapper h1.dashboard-title {
            color: {{theme_color_4}};
        }
        .sos-programme-dashboard-content .btn-secondary {
            background-color: {{theme_color_1}};
        }
        .action-item span.material-icons-outlined.star0 {
            color: {{theme_color_1}};
        }

        #sos-programme-dashboard-content .widgets .dashboard-widget .widget-header {
            background-color: {{theme_color_1}};
        }

        #sos-programme-dashboard-content .widgets .dashboard-widget .widget-content ul li .material-icons-outlined {
            color: {{theme_color_1}};
        }

        #sos-programme-dashboard-content .widgets .dashboard-widget .widget-content .action-award > ul.award-criteria > li.criteria .progress-bar,
        .sos-programme-dashboard-content .widgets .dashboard-widget .widget-content .action-award > ul.award-criteria > li.criteria .progress-bar {
            background-color: {{theme_color_1}};
        }

        #sos-programme-dashboard-sidebar {
            background-color: {{theme_color_2}};
        }

        <!--
        #sos-programme-dashboard-sidebar a:hover,
        #sos-programme-dashboard-sidebar a:focus {
            color: {{theme_color_4}};
        }
        -->

        #sos-programme-dashboard-sidebar .sos-programme-form-card a:hover,
        #sos-programme-dashboard-sidebar .sos-programme-form-card a:focus {
            color: white;
            text-decoration: underline;
        }

        #sos-app-header {
            background-color: {{theme_color_3}};
        }

        #sos-app-footer {
            background-color: {{theme_color_3}};
        }

        .preview-banner {
            background-color: {{theme_color_1}};
        }

        .action-tab-content a,
        .sos-programme-custom-page-content p a,
        .sos-programme-custom-page-content li a {
            color: {{theme_color_4}};
            text-decoration: underline;
        }

        .action-tab-content a:hover,
        .action-tab-content a:focus,
        .sos-programme-custom-page-content p a:hover,
        .sos-programme-custom-page-content p a:focus,
        .sos-programme-custom-page-content li a:hover,
        .sos-programme-custom-page-content li a:focus {
            text-decoration: none;
        }

        .action-item {
            background-color: {{theme_color_2}};
        }

        .btn-toolkit-primary {
            background-color: {{theme_color_1}};
            border-color: {{theme_color_1}};
        }

        .bg-banner-500 {
            --tw-bg-opacity: 1;
            background-color: {{theme_color_1}};
        }

        .programme-socials {
            background-color: {{theme_color_1}};
        }


    </component>

</template>

